import { render, staticRenderFns } from "./DetailAbsentLogs.vue?vue&type=template&id=4614daa6&scoped=true&"
import script from "./DetailAbsentLogs.vue?vue&type=script&lang=js&"
export * from "./DetailAbsentLogs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4614daa6",
  null
  
)

export default component.exports